import {TableCell} from '@mui/material'
import {StyledInterestDiv, StyledShowMoreButton, StyledSpan} from './Styles'
import PropTypes from 'prop-types'

const InterestCell = ({interests, handleShowMore, displayCount, handleShowLess, showLess, handleCellClick}) => {
  const uniqueInterestsSet = [...new Set(interests)]
  const uniqueInterests = uniqueInterestsSet.filter((item) => item !== null)
  return (
    <TableCell>
      <StyledInterestDiv showLess={showLess}>
        {uniqueInterests?.slice(0, displayCount).map((interest) => (
          <StyledSpan key={interest} onClick={handleCellClick}>
            {interest}
          </StyledSpan>
        ))}
        {uniqueInterests?.length > displayCount && (
          <StyledShowMoreButton onClick={handleShowMore}>Show More</StyledShowMoreButton>
        )}
        {showLess && <StyledShowMoreButton onClick={handleShowLess}>Show Less</StyledShowMoreButton>}
      </StyledInterestDiv>
    </TableCell>
  )
}

InterestCell.propTypes = {
  interests: PropTypes.array,
  handleShowMore: PropTypes.func,
  displayCount: PropTypes.number,
  handleShowLess: PropTypes.func,
  showLess: PropTypes.bool,
  handleCellClick: PropTypes.func
}

export default InterestCell
